import React, { useCallback } from 'react'
import { usePostContext } from 'APP/Lib/Context'
import { useSelector } from 'APP/Hooks/redux'
import { useNavigation } from '@react-navigation/native'
import Analytics from 'APP/Services/Analytics'
import { Images } from 'APP/Themes'

import { StyledAvatarContainer, StyledTouchableAvatarContainer, StyledAvatar } from './style'

const Avatar: React.FC = () => {
  const navigation = useNavigation()
  const profile = useSelector((state) => state.patient.profile)

  const { postUser, previousPostIsSameUser, previousPostIsSameDay } = usePostContext()

  const getAvatarSource = useCallback(() => {
    const avatar = postUser?.avatar_url || postUser?.props?.picture || Images.avatarDialogue

    const avatarSource =
      typeof avatar === 'string' && avatar.includes('http') ? { uri: avatar } : avatar
    return avatarSource
  }, [postUser])

  const onPressAvatar = useCallback(() => {
    if (postUser?.app_id && profile?.id) {
      const appId = postUser.app_id
      Analytics.trackEvent('button_click', { button_value: 'Practitioner profile tap' })
      navigation.navigate('practitionerProfile', {
        userAppId: appId,
        profileId: String(profile.id),
      })
    }
  }, [postUser])

  if (previousPostIsSameUser && previousPostIsSameDay) {
    return <StyledAvatarContainer />
  }

  // If there is no postUser, it means the post is from the bot
  if (!postUser) {
    return (
      <StyledAvatarContainer testID="AVATAR_BOT">
        <StyledAvatar source={Images.avatarDialogue} />
      </StyledAvatarContainer>
    )
  }

  return (
    <StyledTouchableAvatarContainer
      onPress={onPressAvatar}
      hitSlop={{ top: 4, bottom: 4, left: 4, right: 4 }}
      testID="AVATAR_USER"
    >
      <StyledAvatar source={getAvatarSource()} />
    </StyledTouchableAvatarContainer>
  )
}

export default Avatar
